import { ViewModel,View, BinderConfigurator } from "binder"
import { BindingPrototypeParser } from "src/binder/parser/prototype/bindingPrototype";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { DataModelClass } from "src/formBuilder/datamodel/structure";
import { GetCurrentDataModelClassMessage } from "../../../templateEditor-viewModel";
import  { BindingEditorView } from "./bindingEditor-view"

export class BindingEditorViewModel extends ViewModel{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        let dataModelClass : DataModelClass = this.handleMessage(new GetCurrentDataModelClassMessage());
        this.propertySuggestions = dataModelClass.GetProperties().map(x=>x.name);
        this.converterSuggestions = BinderConfigurator.GetAllConverterFunctionNames();
    }
    GetDefaultView(): View <ViewModel> {
        return new BindingEditorView();
    }
    public getTypeId(): string {
        return "VM-F58743AD-61D1-446F-90F7-DB935FBC9A26"
    }
    public set propertySuggestions(v: string[]) { this._propertySuggestions = v; } public get propertySuggestions(): string[] { return this._propertySuggestions;} private _propertySuggestions: string[];
    public set propertyName(v: string) { this._propertyName = v; } public get propertyName(): string { return this._propertyName;} private _propertyName: string;
    public set converterSuggestions(v: string[]) { this._converterSuggestions = v; } public get converterSuggestions(): string[] { return this._converterSuggestions;} private _converterSuggestions: string[];
    public set converterName(v: string) { this._converterName = v; } public get converterName(): string { return this._converterName;} private _converterName: string;
    public set reverseConverterName(v: string) { this._reverseConverterName = v; } public get reverseConverterName(): string { return this._reverseConverterName;} private _reverseConverterName: string;
    public set lastValue(v: string) { this._lastValue = v; } public get lastValue(): string { return this._lastValue;} private _lastValue: string;
        
    setValue(value:string){
        this.lastValue = value;
        let isValid = false;
        try{
            if(stringIsNullOrEmpty(value)==false && BindingPrototypeParser.IsBindingExpression(value)){
                var parsedValue = BindingPrototypeParser.Parse(value);
                this.propertyName = parsedValue.path;
                this.converterName = parsedValue.converter;
                this.reverseConverterName = parsedValue.reverseConverter;
                isValid = true;
            }
        }
        catch{

        }

        if(isValid==false){
            this.propertyName = '';
            this.converterName = '';
            this.reverseConverterName = '';
        }
    }
    getValue():string{
        let result = '';
        if(stringIsNullOrEmpty(this.propertyName)==false){
            result = `{Binding ${this.propertyName}`;
        }
        if(stringIsNullOrEmpty(this.converterName)==false){
            result += `,Converter:${this.converterName}`;
        }
        if(stringIsNullOrEmpty(this.reverseConverterName)==false){
            result += `,ReverseConverter:${this.reverseConverterName}`;
        }
        if(stringIsNullOrEmpty(result)==false){
            result +='}';
        }
        return result;
    }

    reset(){
        this.setValue(this.lastValue);
    }
    requestConfirm(){

    }
}
